class Filter {
	static isEnabled(firstName, lastName, email) {
		return Boolean(
			(firstName && firstName.trim() && firstName.trim().length >= 3) ||
			(lastName && lastName.trim() && lastName.trim().length >= 3) ||
			(email && email.trim())
		);
	}
}

export default Filter;
